import { ListUploadFilesResponse } from '@types'
import { CancelTokenSource, Service } from '@tino-frontend/adapters'
import {
  legalEntityFilesTransform,
  progressTransform,
} from 'services/transformers'

export class LegalPersonService {
  constructor(
    private readonly http: Service,
    // @ts-expect-error no unused vars
    private readonly _storage: Service
  ) {}

  getCancelSource(): CancelTokenSource {
    return this.http.generateCancelRef()
  }

  async uploadLegalEntityDocument(
    legalPersonId: string,
    payload: File,
    source?: CancelTokenSource,
    setProgress?: (progress: number, file: File) => void
  ): Promise<unknown> {
    try {
      const { url } = await this.http.get<unknown, { url: string }>(
        `/onboarding/legal-person/${legalPersonId}/legal-entity-document/file/upload`
      )

      const config =
        source && setProgress
          ? {
              cancelToken: source.token,
              onUploadProgress: (progressEvent: any) => {
                setProgress(progressTransform(progressEvent), payload)
              },
            }
          : {}

      await this.http.put(url, payload, config)
      return this.http.post(
        `/onboarding/legal-person/${legalPersonId}/legal-entity-document/file/upload?filename=${payload.name}`
      )
    } catch (e) {
      return Promise.reject(e)
    }
  }

  rejectLegalEntityDocument(
    legalPersonId: string,
    fileId: string
  ): Promise<unknown> {
    return this.http.patch(
      `/onboarding/legal-person/${legalPersonId}/legal-entity-document/files/${fileId}/reject`
    )
  }

  finishUploadLegalEntityDocument(legalPersonId: string): Promise<unknown> {
    return this.http.post(
      `/onboarding/legal-person/${legalPersonId}/legal-entity-document`
    )
  }

  skipUploadLegalEntityDocument(legalPersonId: string): Promise<unknown> {
    return this.http.post(
      `/onboarding/legal-person/${legalPersonId}/legal-entity-document/skip`
    )
  }

  async getLegalEntityDocumentFiles(
    legalPersonId: string
  ): Promise<ListUploadFilesResponse> {
    try {
      const response = await this.http.get<unknown, ListUploadFilesResponse>(
        `/onboarding/legal-person/${legalPersonId}/legal-entity-document/files`
      )
      return legalEntityFilesTransform(response)
    } catch (e) {
      return Promise.reject(e)
    }
  }
}
